import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";
import { ListaMandadosProps } from "../types/mandado-facial.types";
import { formatarDataEuaBrasil } from "../../../../utils/formatters";

export const ListaMandados: React.FC<ListaMandadosProps> = ({ mandados }) => {
  if (!mandados || mandados.length === 0) {
    return null;
  }

  return (
    <MUI.Box sx={{ mt: 3 }}>
      <MUI.Typography
        variant="h6"
        sx={{
          mb: 2,
          fontWeight: "bold",
          color: "error.main",
        }}
      >
        ⚖️ Mandados ({mandados.length})
      </MUI.Typography>

      {mandados.map((mandado) => (
        <MUI.Card
          key={`mandado-${mandado.numeroProcesso}-${mandado.dataCriacao}-${mandado.status}`}
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: "error.lighter",
            border: "1px solid",
            borderColor: "error.light",
          }}
        >
          <MUI.Stack spacing={1}>
            <MUI.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MUIcons.Gavel sx={{ color: "error.main" }} />
              <MUI.Typography variant="body2" color="text.secondary">
                Processo:
              </MUI.Typography>
              <MUI.Typography variant="body1" fontWeight="bold">
                {mandado.numeroProcesso}
              </MUI.Typography>
            </MUI.Box>

            <MUI.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MUIcons.CalendarToday
                sx={{ color: "info.main", fontSize: 20 }}
              />
              <MUI.Typography variant="body2" color="text.secondary">
                Data de Criação:
              </MUI.Typography>
              <MUI.Typography variant="body1">
                {formatarDataEuaBrasil(mandado.dataCriacao)}
              </MUI.Typography>
            </MUI.Box>

            <MUI.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MUIcons.Info sx={{ color: "warning.main", fontSize: 20 }} />
              <MUI.Typography variant="body2" color="text.secondary">
                Status:
              </MUI.Typography>
              <MUI.Chip
                label={mandado.status}
                size="small"
                color={mandado.status === "ATIVO" ? "error" : "default"}
              />
            </MUI.Box>
          </MUI.Stack>
        </MUI.Card>
      ))}
    </MUI.Box>
  );
};
